import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function CadomainsReducer(state = initialState.cadomains, action: any) {
  switch (action.type) {
    case types.SAVE_CADOMAINS_SUCCESS:
      return action.cadomains;
    default:
      return state;
  }
}
